/**
 * Meta (Facebook) Pixel - utilitário para eventos de conversão.
 * PageView é disparado automaticamente no carregamento da página (index.html).
 */

declare global {
  interface Window {
    fbq: (
      action: 'track' | 'init',
      eventName: string,
      params?: Record<string, unknown>
    ) => void;
  }
}

const getFbq = (): Window['fbq'] | null => {
  if (typeof window === 'undefined') return null;
  return window.fbq ?? null;
};

export const trackViewContent = (contentName?: string): void => {
  const fbq = getFbq();
  if (!fbq) return;
  fbq('track', 'ViewContent', contentName ? { content_name: contentName } : undefined);
};

export const trackVideoView = (contentName?: string): void => {
  const fbq = getFbq();
  if (!fbq) return;
  fbq('track', 'VideoView', contentName ? { content_name: contentName } : undefined);
};

export const trackRegister = (): void => {
  const fbq = getFbq();
  if (!fbq) return;
  fbq('track', 'Register');
};
